











 

















const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopRetroTemplatesCard_insights",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInsightsCard_insights"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TopRetroTemplate",
      "kind": "LinkedField",
      "name": "topRetroTemplates",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ReflectTemplate",
          "kind": "LinkedField",
          "name": "reflectTemplate",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "illustrationUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamInsights",
  "abstractKey": null
};
})();

(node ).hash = "4fa5c29c68c3e02f55c34668f26c73d8";

export default node;
